@if (!isSentEmail) {
  <div class="forgot-password">
    <p
      class="title"
      translate
    >
      UI.Forgot_Password.Please-enter-your-username-or-email
    </p>
    <form
      [formGroup]="confirmationForm"
      (ngSubmit)="onSubmit()"
    >
      <div class="form-group">
        <label
          for="usernameOrEmail"
          translate
          >{{ 'Username' | translate }}/{{ 'Email' | translate }}</label
        >
        <input
          id="usernameOrEmail"
          type="text"
          class="form-control"
          formControlName="usernameOrEmail"
        />
        @if (
          usernameOrEmail.invalid &&
          (usernameOrEmail.dirty || usernameOrEmail.touched)
        ) {
          <div class="alert alert-danger">
            @if (usernameOrEmail.errors.required) {
              <div translate>UI.Forgot_Password.UsernameEmail-required</div>
            }
            @if (usernameOrEmail.errors.email) {
              <div translate>
                {{ 'Invalid email address' }}
              </div>
            }
            @if (usernameOrEmail.errors.jip_usernameOrEmail) {
              <div translate>
                {{ errorMessage ? errorMessage.usernameOrEmail : '' }}
              </div>
            }
          </div>
        }
        @if (!isSentEmail && sendEmailFalseMessage) {
          <div class="alert alert-danger mt-2">
            <div>
              {{ sendEmailFalseMessage }}
            </div>
          </div>
        }
      </div>
      <div class="confirm-account-recaptcha">
        <app-google-recapcha
          [formInput]="confirmationForm"
        ></app-google-recapcha>
      </div>
      <!-- error -->
      @if (
        confirmationForm.errors &&
        (confirmationForm.dirty || confirmationForm.touched)
      ) {
        <div
          class="alert alert-danger"
          translate
        >
          {{ errorMessage[formErrorKey] }}
        </div>
      }
      <div class="form-group text-center">
        <button
          type="submit"
          appDebounceClick
          (debounceClick)="onSubmit()"
          class="btn btn-primary"
          [disabled]="
            !confirmationForm.valid ||
            isSubmitting ||
            isSubmitted ||
            !(confirmationForm?.touched || confirmationForm?.dirty)
          "
        >
          @if (isSubmitting) {
            <span
              class="spinner-border spinner-border-sm"
              aria-hidden="true"
            ></span>
          }
          <span>{{ 'UI.Common.Request' | translate }}</span>
        </button>
      </div>
    </form>
  </div>
} @else {
  <div class="email-sent">
    <div class="email-sent__info mt-4">
      <span
        class="info-text"
        [innerHTML]="
          'UI.Forgot_Password.Inform-email-and-follow-link'
            | translate
            | stringReplacement
              : {
                  '{userEmail}':
                    this.sentEmailAddress | emailWrapper: this.sentEmailAddress,
                }
        "
      ></span>
      <span class="mt-3">
        <b translate>UI.Common.Didnot-receive-email</b>
        <span
          class="ms-2"
          translate
          >UI.Common.Please-check-your-spam</span
        >
      </span>
    </div>
    <div class="form-group text-center email-sent__buttons">
      <button
        type="button"
        appDebounceClick
        (debounceClick)="
          resendResetPassword(this.sentEmailAddress, this.resetPasswordToken)
        "
        class="btn btn-secondary"
        [disabled]="isSubmitting"
      >
        @if (isSubmitting) {
          <span
            class="spinner-border spinner-border-sm"
            aria-hidden="true"
          ></span>
        }
        <span> {{ 'UI.Common.Resend-email' | translate }} </span>
      </button>
      <a
        href="/"
        class="btn btn-primary ms-3"
        translate
      >
        UI.Common.OK
      </a>
    </div>
  </div>
}
